import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { RemoveRentalDialogViewModel } from './RemoveRentalDialogViewModel'

export { RemoveRentalDialogViewModel } from './RemoveRentalDialogViewModel'

interface RemoveRentalDialogProps {
  vm: RemoveRentalDialogViewModel
  testId?: string
}

export const RemoveRentalDialog = observer(function RemoveRentalDialog({
  vm,
  testId,
}: RemoveRentalDialogProps) {
  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Remove info about {vm.propertyName}?
        </ModalDialogTitle>
        <ModalDialogDescription>
          This will remove the rental property from this tax preparation. This
          action cannot be undone.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Yes, delete"
            variant="destructive"
            onPress={vm.confirm}
            testId={testId ? `${testId}-confirm-button` : undefined}
          />
          <Button
            label="Cancel"
            variant="outline"
            onPress={vm.closeDialog}
            testId={testId ? `${testId}-cancel-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
